const countries = [
  { label: 'United States', value: 'US' },
  { label: 'Canada', value: 'CA' },
];

export default countries;

export const getCountryName = (countryCode) => {
  const country = countries.find((c) => c.value === countryCode);
  return country ? country.label : countryCode;
};
